export default __webpack_public_path__ + "和.png";